import styled from "@emotion/native"
import { Text } from "./Typography"
import EllipseIcon from "../assets/ellipse.svg"
import BankIcon from "../assets/pepicons-pencil_bank-circle-filled.svg"
import { Spacing } from "./Spacing"

type AccountCardProps = {
  bankName: string
  accountMask: string
}

export function AccountCard(props: AccountCardProps) {
  const { bankName, accountMask } = props

  return (
    <AccountCardContainer>
      <BankIcon viewBox="0 0 32 32" width={20} height={20} />
      <Spacing right={16} />
      <NameAndDigitsContainer>
        <Text type="label2">{bankName}</Text>
        <AccountMask>
          {Array.from(Array(4)).map((_, i) => (
            <EllipseIcon key={String(i)} />
          ))}
          <Spacing left={3} />
          <Text type="label2" color="secondary">
            {accountMask}
          </Text>
        </AccountMask>
      </NameAndDigitsContainer>
    </AccountCardContainer>
  )
}

const AccountCardContainer = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const NameAndDigitsContainer = styled.View``

const AccountMask = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 4px;
`
